import React, { useEffect, useRef, useState, useCallback } from "react"; // Tambah useCallback
import { useInfiniteQuery } from "@tanstack/react-query";
import axios from "axios";
import { useIntersection } from "@mantine/hooks";
import { useNavigate } from "react-router-dom";
import { CaretLeft } from "@phosphor-icons/react";
import CardAnnouncement from "./component/CardAnnouncement";
import { useCookies } from "react-cookie";
import { jwtDecode } from "jwt-decode";

function HistoryAnnounce() {
  const routerPush = useNavigate();
  const [keyword, setKeyword] = useState("");
  const [debouncedKeyword, setDebouncedKeyword] = useState("");
  
  const ocKeyword = (e) => {
    e.preventDefault()
    const { value } = e.target;
    setKeyword(value);
  };

    const [isAdmin, setIsAdmin] = useState(false);
    const [cookies] = useCookies(["token"]);
    const navigate = useNavigate();
  
    // Menggunakan useEffect untuk navigasi
    useEffect(() => {
      const checkker = async() => {
        if (
          !cookies.token ||
          cookies.token === null ||
          cookies.token === undefined
        ) {
          navigate("/login");
        } else {
          try {
            // Pastikan cookies.token adalah string dan valid
            const token = cookies.token;
            if (typeof token === "string" && token) {
              const userName = jwtDecode(token).email;
              const id_usr = await axios.get(`${process.env.REACT_APP_SERVER}/api/user/${userName}`)
              const position = id_usr.data.payload.datas.posisi === "Admin"
              setIsAdmin(position)
            } else {
              navigate("/login");
            }
          } catch (error) {
            navigate("/login");
          }
        }
      }
      checkker()
    }, [cookies.token, navigate]); // Menambahkan dependencies
  

  // Efek untuk debounce keyword
  useEffect(() => {
    const timerId = setTimeout(() => {
      setDebouncedKeyword(keyword);
    }, 1000); // Delay 300ms

    return () => clearTimeout(timerId); // Cleanup timer
  }, [keyword]);

  // Gunakan useCallback untuk memoize fungsi fetchProjects
  const fetchProjects = useCallback(async ({ pageParam = Number.MAX_SAFE_INTEGER }) => {
    const res = await axios.get(
      `${process.env.REACT_APP_SERVER}/api/report?cursor=${pageParam}&keyword=${debouncedKeyword}`
    );
    return res.data;
  }, [debouncedKeyword]); // debouncedKeyword sebagai dependency

  const {
    data,
    error,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isFetchingNextPage,
    status,
    refetch, // Tambahkan refetch
  } = useInfiniteQuery({
    queryKey: ["projects", debouncedKeyword],
    queryFn: fetchProjects,
    getNextPageParam: (lastPage) => {
      return lastPage.nextCursor ? lastPage.nextCursor : undefined;
    },
    initialPageParam: Number.MAX_SAFE_INTEGER,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    staleTime: Infinity // Tambah ini untuk mencegah refetch otomatis
  });

  const lastPostRef = useRef(null);
  const { ref, entry } = useIntersection({
    root: lastPostRef.current,
    threshold: 1,
  });

  const _posts = data?.pages.flatMap((page) => page.data);

  useEffect(() => {
    if (entry?.isIntersecting) fetchNextPage();
  }, [entry, fetchNextPage]);

  if (status === "pending") return <></>;
  if (status === "error") return <p>{error}</p>;
  if (status === "loading") return <p>Loading...</p>;

  const handlePrev = () => {
    routerPush(isAdmin ? "/admin" : "/");
  };

  return (
    <div className="relative min-h-svh bg-slate-100 w-full flex flex-col gap-8  px-4 pt-6 pb-28">
      {/*// * Header */}
      <p className="text-lg font-bold text-center">Announcement</p>
      <div className="absolute cursor-pointer text-black " onClick={handlePrev}>
        <CaretLeft size={24} weight="bold" />
      </div>
      {/* // * SEARCH */}
      <div className="flex gap-2  items-center">
        <label className="bg-slate-50 w-full flex-1 input input-bordered flex items-center gap-2">
          <input
            onChange={ocKeyword}
            type="text"
            className="grow"
            placeholder="Search"
          />
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 16 16"
            fill="currentColor"
            className="h-4 w-4 opacity-70"
          >
            <path
              fillRule="evenodd"
              d="M9.965 11.026a5 5 0 1 1 1.06-1.06l2.755 2.754a.75.75 0 1 1-1.06 1.06l-2.755-2.754ZM10.5 7a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z"
              clipRule="evenodd"
            />
          </svg>
        </label>
      </div>
      {/* //* CARDS */}
      <div className="grid sm:grid-cols-2 gap-4">
        {_posts?.map((post, i) => {
          if (i === _posts.length - 1)
            return (
              <div key={post.id} ref={ref}>
                <CardAnnouncement cb={post} />
              </div>
            );
          return (
            <CardAnnouncement cb={post} key={post.id} />
          );
        })}
      </div>

      {/* //* STATUS FETCHING */}
      <div>
        <button
          onClick={() => fetchNextPage()}
          disabled={!hasNextPage || isFetchingNextPage}
        >
          {isFetchingNextPage
            ? "Loading more..."
            : hasNextPage
              ? "Load More"
              : "Nothing more to load"}
        </button>
      </div>
    </div>
  );
}

export default HistoryAnnounce;


// // Projects.js
// import React, { useEffect, useRef, useState } from "react";
// import { useInfiniteQuery } from "@tanstack/react-query";
// import axios from "axios";
// import { useIntersection } from "@mantine/hooks";
// import { useNavigate } from "react-router-dom";
// import { CaretLeft } from "@phosphor-icons/react";
// import CardHistoryLogistics from "./component/CardHistoryLogistics";

//Report HistoryLogistics() {
//   const routerPush = useNavigate();
//   const [keyword, setKeyword] = useState("");
//   const [debouncedKeyword, setDebouncedKeyword] = useState("");
//   const handlePrev = () => {
//     routerPush("/logistics");
//   };
//   const ocKeyword = (e) => {
//     // e.preventDefault(); // Hapus baris ini
//     const { value } = e.target;
//     setKeyword(value);
//   };
//   const fetchProjects = async ({ pageParam = Number.MAX_SAFE_INTEGER }) => {
//     const res = await axios.get(
//       `${process.env.REACT_APP_SERVER}/api/projects?cursor=${pageParam}&keyword=${debouncedKeyword}`
//     );
//     return res.data;
//   };

//   // Efek untuk debounce keyword
//   useEffect(() => {
//     const timerId = setTimeout(() => {
//       setDebouncedKeyword(keyword);
//     }, 300); // Delay 300ms

//     return () => clearTimeout(timerId); // Cleanup timer
//   }, [keyword]);

//   const {
//     data,
//     error,
//     fetchNextPage,
//     hasNextPage,
//     isFetching,
//     isFetchingNextPage,
//     status,
//   } = useInfiniteQuery({
//     queryKey: ["projects", debouncedKeyword],
//     queryFn: fetchProjects,
//     getNextPageParam: (lastPage) => {
//       return lastPage.nextCursor ? lastPage.nextCursor : undefined;
//     },
//     initialPageParam: Number.MAX_SAFE_INTEGER,
//     refetchOnMount: false, // Opsi untuk menghindari refetch saat mount
//     refetchOnWindowFocus: false, // Opsi untuk menghindari refetch saat window focus
//     refetchOnReconnect: false, // Opsi untuk menghindari refetch saat reconnect
//   });

//   const lastPostRef = useRef(null);
//   const { ref, entry } = useIntersection({
//     root: lastPostRef.current,
//     threshold: 1,
//   });

//   const _posts = data?.pages.flatMap((page) => page.data);

//   useEffect(() => {
//     if (entry?.isIntersecting) fetchNextPage();
//   }, [entry]);

//   if (status === "pending") return <></>;
//   if (status === "error") return <p>{error}</p>;
//   if (status === "loading") return <p>Loading...</p>;

//   return (
//     <div className="relative min-h-svh bg-slate-100 w-full flex flex-col gap-8  px-4 pt-6 pb-28">
//       {/*// * Header */}
//       <p className="text-lg font-bold text-center">History Logistic</p>
//       <div className="absolute cursor-pointer text-black " onClick={handlePrev}>
//         <CaretLeft size={24} weight="bold" />
//       </div>
//       {/* // * SEARCH */}
//       <div className="flex gap-2  items-center">
//         <label className="bg-slate-50 w-full flex-1 input input-bordered flex items-center gap-2">
//           <input
//             onChange={ocKeyword}
//             type="text"
//             className="grow"
//             placeholder="Search"
//           />
//           <svg
//             xmlns="http://www.w3.org/2000/svg"
//             viewBox="0 0 16 16"
//             fill="currentColor"
//             className="h-4 w-4 opacity-70"
//           >
//             <path
//               fillRule="evenodd"
//               d="M9.965 11.026a5 5 0 1 1 1.06-1.06l2.755 2.754a.75.75 0 1 1-1.06 1.06l-2.755-2.754ZM10.5 7a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z"
//               clipRule="evenodd"
//             />
//           </svg>
//         </label>
//         {/* <button onClick={handleHistory} className="btn bg-slate-50 text-slate-600">
//             <ClockCounterClockwise size={24} />
//           </button> */}
//       </div>
//       {/* //* CARDS */}
//       <div className="grid sm:grid-cols-2 gap-4">
//         {_posts?.map((post, i) => {
//           if (i === _posts.length - 1)
//             return (
//               <div key={post.id} ref={ref}>
//                 <CardHistoryLogistics cb={post} />
//               </div>
//             );
//           return (
//             <CardHistoryLogistics cb={post} key={post.id} />
//           );
//         })}
//       </div>

//       {/* //* STATUS FETCHING */}
//       <div>
//         <button
//           onClick={() => fetchNextPage()}
//           disabled={!hasNextPage || isFetchingNextPage}
//         >
//           {isFetchingNextPage
//             ? "Loading more..."
//             : hasNextPage
//             ? "Load More"
//             : "Nothing more to load"}
//         </button>
//       </div>
//     </div>
//   );
// }

// export default HistoryLogistics;
